import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { MenuSection } from "@/components/landing/MenuSection";
import { BranchesSection } from "@/components/landing/BranchesSection";
import { WhyUs } from "@/components/landing/WhyUs";
import { OrderSection } from "@/components/landing/OrderSection";
import { CareersSection } from "@/components/landing/CareersSection";
import { FranchiseSection } from "@/components/landing/FranchiseSection";
import { Footer } from "@/components/landing/Footer";
import LoginPage from "@/pages/LoginPage";
import PanelPage from "@/pages/PanelPage";
import GelAlPage from "@/pages/GelAlPage";
import PaymentResultPage from "@/pages/PaymentResultPage";

const CheckerDivider = () => <div className="checker-strip" aria-hidden="true" />;

const LandingPage = () => {
  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <CheckerDivider />
        <MenuSection />
        <CheckerDivider />
        <BranchesSection />
        <CheckerDivider />
        <WhyUs />
        <CareersSection />
        <FranchiseSection />
        <OrderSection />
      </main>
      <Footer />
      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/gel-al" element={<GelAlPage />} />
            <Route path="/odeme-sonuc" element={<PaymentResultPage />} />
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/panel" element={<PanelPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
